import React from "react";
import { Modal, Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";
import { buildContractViewHtml } from "app/containers/ContractManagement/ContractEditor/contractView";
import "./ContractPreviewLightbox.css";

// Figma 10795:46036 (Job Setup trigger send, #3 Preview).
const ContractPreviewLightbox = ({ show, onHide, template, data }) => {
  const html =
    show && template?.content_html
      ? buildContractViewHtml(template.content_html, data || {})
      : "";

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="contract-preview-lightbox"
      dialogClassName="contract-preview-dialog"
      contentClassName="contract-preview-content"
      backdropClassName="contract-preview-backdrop"
    >
      <div className="contract-preview-topbar">
        <h5 className="contract-preview-title">Contract Preview</h5>
        <Button
          variant="link"
          className="contract-preview-close"
          onClick={onHide}
          aria-label="Close"
        >
          <Icon path={mdiClose} size="16px" />
        </Button>
      </div>
      <div className="contract-preview-doc-area">
        {html ? (
          <div
            className="contract-view-doc contract-preview-doc"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        ) : (
          <p className="contract-preview-empty">
            This contract template has no content yet.
          </p>
        )}
      </div>
    </Modal>
  );
};

export default ContractPreviewLightbox;
